import React from 'react'
import { Form as RsForm, Row, Col, Label } from 'reactstrap'
import { Validator } from 'components/validation'
import { Input } from 'components/inputs'

const Form = (props) => {
  const { disabled, data, updateEntity, localize } = props
  const { entity } = data
  if (!entity) { return null }
  return (
    <RsForm>
      <Row>
        <Col sm={props.isInDialog ? 12 : 6}>
          <Label>{localize('common.name')}</Label>
          <Validator name='name' value={entity.name} required maxLength={255} disabled={disabled}>
            <Input value={entity.name} onChange={updateEntity('name')} placeholder={localize('common.name')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Label>{localize('storagePlaces.capacityInLitres')}</Label>
          <Validator name='availableCapacityInLitres' value={entity.availableCapacityInLitres} required disabled={disabled}>
            <Input isNumeric value={entity.availableCapacityInLitres} onChange={updateEntity('availableCapacityInLitres')} placeholder={localize('storagePlaces.capacityInLitres')} disabled={disabled} />
          </Validator>
        </Col>
        <Col sm={6}>
          <Label>{localize('storagePlaces.capacityInBottlesCount')}</Label>
          <Validator name='availableCapacityInBottlesCount' value={entity.availableCapacityInBottlesCount} required disabled={disabled}>
            <Input isNumeric value={entity.availableCapacityInBottlesCount} onChange={updateEntity('availableCapacityInBottlesCount')} placeholder={localize('storagePlaces.capacityInBottlesCount')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Label>{localize('storagePlaces.temperature')}</Label>
          <Validator name='temperature' value={entity.temperature} required disabled={disabled}>
            <Input isNumeric value={entity.temperature} onChange={updateEntity('temperature')} placeholder={localize('storagePlaces.temperature')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <Label>{localize('storagePlaces.comment')}</Label>
          <Validator name='comment' value={entity.comment} disabled={disabled}>
            <Input value={entity.comment} onChange={updateEntity('comment')} placeholder={localize('storagePlaces.comment')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
    </RsForm>
  )
}

export default Form